import { SelectionChangedEvent, GridReadyEvent, RowNode } from "ag-grid-community";
import { useCallback, useRef, useState } from "react";
import { Order, TOnSiteOrderType } from "src/app/types/orders/order";
import { BaseAgGrid } from "../grid/BaseAgGrid";
import { AgGridReact } from "ag-grid-react";
import { useSiteAnalyzeOnSiteGridColumns } from "./SiteAnalyzeOnSiteGridColumns/useSiteAnalyzeOnSiteGridColumns";
import Pacman from "../layout/Pacman";
import { UpsertEditOnSiteModalContainer } from "src/app/containers";
import { OrderOnSiteGrid } from "src/app/types/orders/onSite";

export interface ISiteAnalyzeOnSiteGrid {
    rowData?: Array<OrderOnSiteGrid>;
    refreshRowData?(): void;
    refreshHistoryData?(): void;
    setSelectedRows?: React.Dispatch<React.SetStateAction<any[]>>;
    onSelectionChanged?: (event: any) => void;
    orderType: TOnSiteOrderType;
    gridRef?: React.RefObject<any>;
    isVisible?: boolean;
    historyByMoneySiteOnSite?: Array<OrderOnSiteGrid>;
    isHistoryView?: boolean;
    loading?: boolean;
}
const SiteAnalyzeOnSiteGrid = (props: ISiteAnalyzeOnSiteGrid) => {
    const {
        rowData,
        setSelectedRows = () => {},
        gridRef: externalGridRef,
        orderType,
        isVisible,
    } = props;

    const localGridRef = useRef<AgGridReact<any>>(null);

    const effectiveGridRef = externalGridRef || localGridRef;

    const [editModal, setEditModal] = useState(false);
    const [entity, setEntity] = useState<any | undefined>();

    const handleModals = (modal: "edit", data?: Order) => {
        switch (modal) {
            case "edit": {
                setEditModal((value) => !value);
                break;
            }
        }
        setEntity({
            orderId: data?.id,
        });
    };

    const gridColumns = useSiteAnalyzeOnSiteGridColumns(orderType, handleModals);

    const onSelectionChanged = (event: SelectionChangedEvent) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRows(selectedRows);
        if (props.onSelectionChanged) {
            props.onSelectionChanged(event);
        }
    };

    const onGridReady = useCallback(
        (params: GridReadyEvent) => {
            const gridApi = params.api;
            gridApi.sizeColumnsToFit();

            window.addEventListener("resize", function () {
                if (effectiveGridRef?.current?.api) {
                    setTimeout(function () {
                        effectiveGridRef?.current?.api.sizeColumnsToFit();
                    });
                }
            });
        },
        [rowData]
    );

    const doesExternalFilterPass = useCallback((node: RowNode): boolean => {
        if (node.data) {
            return !!node.data.active;
        }
        return true;
    }, []);

    const loadingPacMen = () => (
        <div className="d-flex">
            <Pacman />
        </div>
    );

    return (
        <>
            <div className="ag-theme-balham" style={{ height: isVisible ? "100%" : "900px" }}>
                <BaseAgGrid
                    rowSelection="multiple"
                    listHandler={() => {}}
                    loadingOverlayComponent={loadingPacMen}
                    onSelectionChanged={onSelectionChanged}
                    gridRef={effectiveGridRef}
                    rowData={rowData}
                    columnDefs={gridColumns}
                    isExternalFilterPresent={() => true}
                    onModelUpdated={() => {}}
                    doesExternalFilterPass={doesExternalFilterPass}
                    onGridReady={onGridReady}
                />
            </div>
            {editModal && entity && (
                <UpsertEditOnSiteModalContainer
                    entity={entity}
                    handleClose={() => handleModals("edit")}
                />
            )}
        </>
    );
};

export default SiteAnalyzeOnSiteGrid;
